export default "__VITE_ASSET__TwT6poe1__"